export default "__VITE_ASSET__BkJW5eO0__"